import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import * as MenuAction from '../actions/MenuAction';
import * as ManageFormAction from '../actions/ManageFormAction';
import ManageFormStore from '../stores/ManageFormStore';
import swal from 'sweetalert';
import { MapInteractionCSS } from 'react-map-interaction';
let isDeletecount = 0;
let dragItem = null
let dragOverItem = null
let quesIndex = null; //ww-967 - bug fixing - to display the dont repeat question correctly.
class AddFormComponent extends Component {
    constructor(props) {
        super(props);
        this.handleQues = this.handleQues.bind(this);
        this.handleOptions = this.handleOptions.bind(this);
        this.onChooseCntrl = this.onChooseCntrl.bind(this);
        this.handleFormName = this.handleFormName.bind(this);
        this.addOptions = this.addOptions.bind(this);
        this.saveQues = this.saveQues.bind(this);
        this.saveImg = this.saveImg.bind(this);
        this.bindFormQues = this.bindFormQues.bind(this);
        this.bindOptions = this.bindOptions.bind(this);
        this.deleteQues = this.deleteQues.bind(this);
        this.cancel = this.cancel.bind(this);
        this.saveImgResponse = this.saveImgResponse.bind(this);
        this.manageFormNavigation = this.manageFormNavigation.bind(this);
        this.statusChange = this.statusChange.bind(this)
        let currentQueslen = -1
        if (this.props.location.state.quesArray.length != 0) {
            currentQueslen = Math.max(...this.props.location.state.quesArray.map(o => o.QUESTIONNO))
        }
        let quesoriginal = JSON.parse(JSON.stringify(this.props.location.state.quesArray));
        let tempquesoriginal = JSON.parse(JSON.stringify(this.props.location.state.quesArray));
        let tempoptions = JSON.parse(JSON.stringify(this.props.location.state.options));
        let optionsoriginal = JSON.parse(JSON.stringify(this.props.location.state.options));
        this.state = {
            formAction: this.props.location.state.name,
            formName: this.props.location.state.formName,
            ques: 1,
            formType: this.props.location.state.type,
            placeHolderText: "",
            prefillText: "",
            characterLimit: "",
            additionalInfoText: "",
            minNumber: "",
            maxNumber: "",
            isActive: true,
            isAdditionalInfo: false,
            isMandatoryField: false,
            cntrlType: "",
            tempOption: tempoptions,
            options: optionsoriginal,
            filteredOptions: [],
            tempQues: (tempquesoriginal == undefined || tempquesoriginal == null ? "" : tempquesoriginal.sort((a, b) => a.QUESTIONNO > b.QUESTIONNO ? 1 : -1)),
            quesArray: (quesoriginal == undefined || quesoriginal == null ? "" : quesoriginal),
            currentQues: currentQueslen, formDetail: this.props.location.state.formDetail,
            isAddText: true, isAddImage: false, addLabel: "", addDesc: "", attachment: [],//*[01/23/22, PC_WW-578_01], Priyanka D */
            allowSixUpload: 0,
            showInfo: true,
            disableBtn: false, lastQuestion: null,
            hasChanges: false
        }
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.findExistingUploads();
        ManageFormStore.on('saveFormResponse', this.saveFormResponse.bind(this));
        ManageFormStore.on('attachmentResponse', this.loadAttachments.bind(this));
        ManageFormStore.on('rmvAttach', this.removeAttachmentResponse.bind(this));
        ManageFormStore.on('saveImg', this.saveImgResponse.bind(this));
        this.findLastQuestion();
    }
    componentWillUnmount() {
        ManageFormStore.removeListener('saveFormResponse', this.saveFormResponse);
        ManageFormStore.removeListener('attachmentResponse', this.loadAttachments);
        ManageFormStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        ManageFormStore.removeListener('saveImg', this.saveImgResponse);
    }

    findLastQuestion = () => {
        // Check if tempQues is not empty or undefined
        if (this.state.tempQues && this.state.tempQues.length > 0) {
            // Calculate lastQuestion only if tempQues is not empty
            const maxQuestionNo = Math.max(...this.state.tempQues.map(obj => obj.QUESTIONNO));
            this.setState({ lastQuestion: maxQuestionNo });
        } else {
            // Handle the case when tempQues is empty or undefined
            this.setState({ lastQuestion: 0 }); // or any default value you prefer
        }
    }

    findExistingUploads = () => {
        let localCheckUploads = 0;
        this.state.quesArray.map((value, index) => {
            if (value.TYPE == "ATTACHMENT") {
                localCheckUploads = localCheckUploads + 1;
            }
        })
        this.setState({ allowSixUpload: this.state.allowSixUpload + localCheckUploads });
    }



    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = ManageFormStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            document.getElementById("lblerror").innerText = "";
            let tempAttachments = this.state.attachment;
            tempAttachments.splice(0, 1);
            this.setState({ attachment: tempAttachments, lblerror: "" });
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in removing Image"
            });
        }
    }
    loadAttachments = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = ManageFormStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            /*[03/23/22,PC_32,WAL-511], Priyanka D */
            let attachmentResponse = JSON.parse(ManageFormStore.attachmentResponse);
            this.setState({ attachment: attachmentResponse });
        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };
    saveImgResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let saveImgResponse = JSON.parse(ManageFormStore.saveImgResponse);
        this.setState({ attachment: saveImgResponse });
        this.saveQues();
    }
    bindOptions = (val) => {
        let tempOption = this.state.options.filter((item) => item.QUESTIONNO == val.QUESTIONNO && item.FORMNAME == val.FORMNAME && item.ISDELETE.toLowerCase() != "y")
        tempOption = tempOption.sort((a, b) => a.OPTIONNO > b.OPTIONNO ? 1 : -1)
        switch (val.TYPE.toLowerCase()) {
            case "text": {
                return (
                    <div class="w-100 float-left mb-3">
                        <input class="form-control col-md-4 rounded-0 custom-form" type="text" value={val.PREFILLTEXT != "" && val.PREFILLTEXT != " " && val.PREFILLTEXT != null && val.PREFILLTEXT != undefined ? val.PREFILLTEXT : val.PLACEHOLDERTEXT} disabled="true" />
                    </div>
                )
                break;
            } case "choice": {
                return tempOption.map((item, index) => {
                    return (
                        <div class="w-100 float-left">
                            <div class="d-flex align-items-center">
                                <span class="pr-3"><img src="images/grey-radio.svg" alt="choice-indication" /></span>
                                <label class="font-regular font-14 m-0  mt-1">{item.OPTIONS}</label>
                            </div>
                        </div>)
                })
            } case "check": {
                return tempOption.map((item, index) => {
                    return (
                        <div class="d-flex align-items-center">
                            <span class="pr-3"><img src="images/grey-check.svg" alt="check-indication" /></span>
                            <label class="font-regular font-14 m-0  mt-1">{item.OPTIONS}</label>
                        </div>
                    )
                })
                break;

            } case "number": {
                return (
                    <div class="w-100 float-left mb-3 border-bottom pb-4">
                        <input class="form-control custom-form" type="text" value="" />
                    </div>
                )
                break;
            } case "textarea": {
                return (
                    <div class="w-100 float-left mb-3 border-bottom pb-4">
                        <textarea class="form-control custom-form" id="exampleFormControlTextarea1" rows="3"
                            value={val.PREFILLTEXT != "" && val.PREFILLTEXT != " " && val.PREFILLTEXT != null && val.PREFILLTEXT != undefined ? val.PREFILLTEXT : val.PLACEHOLDERTEXT} readonly></textarea>
                    </div>
                )
                break;
            } case "dropdown": {
                return tempOption.map((item, index) => {
                    return (
                        <div class="w-100 float-left mb-3">
                            <input class="form-control col-md-4 rounded-0 custom-form" type="text" value={item.OPTIONS} disabled="true" />
                        </div>
                    )
                })
                break;
            }
            case "attachment": {
                return (
                    <div class="w-100 mb-3">
                        <button class="btn-preview font-medium font-14 px-3 py-2"><img src="Images/upload-yellow-icon.svg" class="mr-2" />Upload</button>
                    </div>
                )
                break;
            }


        }
    }
    saveFormResponse = () => {
        //
        let saveFormResponse = JSON.parse(ManageFormStore.saveFormResponse);
        let status = saveFormResponse.status;
        if (status != undefined && status != null) {
            if (status[0] != undefined && status[0] != null) {
                if (status[0].lblerror != null && status[0].lblerror != "" && status[0].lblerror != " ") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: status[0].lblerror
                    }).then(() => {
                        this.setState({ hasChanges: false });
                    });
                    if (status[0].lblerror.toLowerCase() == "form saved successfully") {
                        this.setState({ quesArray: this.state.tempQues, options: this.state.options, filteredOptions: [] })
                        this.props.history.push({
                            pathname: '/manageforms',
                        });
                    }
                    else {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    }
                }
            }
        }
    }
    deleteQues = (e, val) => {
        e.preventDefault();
        let ques = this.state.tempQues;
        let index = ques.findIndex(y => y.QUESTIONNO == val.QUESTIONNO);
        ques[index].ISDELETE = "Y";
        if (val.TYPE.toLowerCase() == "attachment") {
            this.setState({ allowSixUpload: this.state.allowSixUpload - 1 })
        }
        this.setState({
            tempQues: ques.sort((a, b) => a.QUESTIONNO > b.QUESTIONNO ? 1 : -1)
        })
        this.findLastQuestion();
    }
    statusChange = (e, val) => {
        
        let ques = this.state.tempQues
        let index = ques.findIndex(y => y.QUESTIONNO == val.QUESTIONNO);
        ques[index].ISACTIVE = (val.ISACTIVE == "Y" ? "N" : "Y")
        this.setState({ tempQues: ques.sort((a, b) => a.QUESTIONNO > b.QUESTIONNO ? 1 : -1), isActive: ques[index].ISACTIVE, hasChanges: true })
    }
    editQues = (e, val, questionIndex) => {
        e.preventDefault()
        let options = JSON.parse(JSON.stringify(this.state.options));
        let attachment = []
        $('#add-question').modal('show');
        if (val.ATTACHMENT != "" && val.ATTACHMENT != " " && val.ATTACHMENT != undefined && val.ATTACHMENT != null) {
            let localArray = {
                FileName: val.ATTACHMENT_FILE_NAME,
                FilePath: val.ATTACHMENT
            }
            attachment.push(localArray)
        }
        if (val.TYPE.toLowerCase() == "attachment") {
            this.setState({ showInfo: false })
        }
        else {
            this.setState({ showInfo: true })
        }
        if (this.state.allowSixUpload >= 6) {
            this.setState({ disableBtn: true })
        }
        else {
            this.setState({ disableBtn: false })
        }

        this.setState({
            quesType: "Edit Question",
            formType: "edit",
            isAddclick: false,
            currentQues: val.QUESTIONNO,
            question: val.QUESTIONS,
            isAdditionalInfo: (((val.ADDITIONALINFO != "" && val.ADDITIONALINFO != null && val.ADDITIONALINFO != " " && val.ADDITIONALINFO != undefined) || (val.ATTACHMENT != "" && val.ATTACHMENT != null && val.ATTACHMENT != " " && val.ATTACHMENT != undefined)) ? true : false),
            additionalInfotext: val.ADDITIONALINFO,
            isAddText: (((val.ADDITIONALINFO != "" && val.ADDITIONALINFO != null && val.ADDITIONALINFO != " " && val.ADDITIONALINFO != undefined) || (val.ATTACHMENT == "" || val.ATTACHMENT == null || val.ATTACHMENT == " " || val.ATTACHMENT == undefined)) ? true : false),
            isAddImage: (val.ATTACHMENT != "" && val.ATTACHMENT != null && val.ATTACHMENT != " " && val.ATTACHMENT != undefined ? true : false),
            attachment_file_name: val.ATTACHMENT_FILE_NAME,
            attachment: attachment,
            addLabel: val.ATTACHMENT_LABEL,
            addDesc: val.ATTACHMENT_DESC,
            cntrlType: val.TYPE,
            filteredOptions: options.filter((item) => item.QUESTIONNO == val.QUESTIONNO && item.FORMNAME == val.FORMNAME),
            characterLimit: val.MAXLENGTH,
            placeHolderText: val.PLACEHOLDERTEXT,
            prefillText: val.PREFILLTEXT,
            minNumber: val.MINNUMBER,
            maxNumber: val.MAXNUMBER,
            isMandatoryField: (val.MANDATORY == "Y" ? true : false),
            isActive: (val.ISACTIVE == "Y" ? true : false),
            quesIndex: questionIndex
        })
    }
    onDragStart = (e, index) => {
        if (index >= 6) {
            dragItem = index;
            let stop = true;
            $(".draggable").on("drag", function (e) {



                stop = true;



                if (e.originalEvent.clientY < 150) {
                    stop = false;
                    scroll(-1)
                }



                if (e.originalEvent.clientY > ($(window).height() - 150)) {
                    stop = false;
                    scroll(1)
                }



            });



            $(".draggable").on("dragend", function (e) {
                stop = true;
            });



            let scroll = function (step) {
                let scrollY = $(window).scrollTop();
                $(window).scrollTop(scrollY + step);
                if (!stop) {
                    setTimeout(function () { scroll(step) }, 20);
                }
            }
        }
        else {
            e.preventDefault();
        }
        
    }

    onDragEnter = (e, index) => {
        if (index >= 6 ||dragItem >= 6) {
            dragOverItem = index;
        } else {
            dragOverItem = null;
        }
       
    }
    onHandleSort = () => {
        if (dragOverItem && dragOverItem >= 6) {
            let { tempQues } = this.state;
            let duplicateTemp = [...tempQues]
            let drggedcontent = duplicateTemp.splice(dragItem, 1)[0]

            duplicateTemp.splice(dragOverItem, 0, drggedcontent)
            
            this.setState({ tempQues: duplicateTemp });
        }
        dragItem = null
        dragOverItem = null
        
    }

    bindURL = (ADDITIONALINFO) => {
        let rex = SDIConstants.urlregexp;
        let additionalinfoStr = ADDITIONALINFO.split(' ');
        return additionalinfoStr.map((value) => {
            if (!rex.test(value)) {
                return (<label>{value}&nbsp;</label>)
            }
            else {
                return (<a href={value} target="_blank">{value}&nbsp;</a>)
            }

        })
    }
    viewMore = (e, val) => {
        this.setState({ attachImg: val.ATTACHMENT, currentLabel: val.ATTACHMENT_LABEL, currentDesc: val.ATTACHMENT_DESC })
        $('#Attachment').modal('show');
    }
    bindFormQues = () => {
        return this.state.tempQues.map((val, index) => {
            let draggable = false
            if ((this.state.formType == "edit" || this.state.formType == "add") && index > 5 ) {
                draggable = true
            }
            if (val.ISDELETE == "N") {
                return (
                    <div class="w-100 p-3 float-left question-container mb-4 draggable" draggable={draggable}
                        onDragStart={(e) => this.onDragStart(e, index)}
                        onDragEnter={(e) => this.onDragEnter(e, index)}
                        onDragEnd={this.onHandleSort}
                        onDragOver={(e, index) => {
                            if ((this.state.formType == "edit" || this.state.formType == "add") && dragItem >= 6 && index >= 6) {
                                e.preventDefault();  
                            }
                        }}
                       >
                        <div class="w-100 justify-content-between d-md-flex d-block mb-3">
                            <label class=" p-0 font-14 font-medium" style={{ width: "75%", wordWrap: "break-word" }} >{val.QUESTIONS}
                                {val.MANDATORY == "Y" ? <span class="required-red">*</span> : null}
                                {val.ADDITIONALINFO != "" && val.ADDITIONALINFO != " " && val.ADDITIONALINFO != null && val.ADDITIONALINFO != undefined ?
                                    <span className="info-container info-container-form ml-2">
                                        <img className="mb-1" src="Images/info-icon.png" />
                                        <span className="ml-2 mt-2 info-content info-formposition">
                                            {this.bindURL(val.ADDITIONALINFO)}
                                        </span>
                                    </span> : null}
                                {val.ATTACHMENT != undefined && val.ATTACHMENT != null && val.ATTACHMENT != [] && val.ATTACHMENT != "" && val.ATTACHMENT != " " ?
                                    <label class="view-more pl-1"> <a href="#" class="pr-1" data-toggle="modal" onClick={(e) => this.viewMore(e, val)}>More Info</a></label> : null}
                            </label>

                            {this.state.formType != "view"  && index > 5  ?
                                <div class="d-flex align-items-center justify-content-end">
                                   
                                    <p class="m-0 mr-2 font-regular font-14">Status :</p>
                                    <label class="switch m-0 mr-2">
                                        <input type="checkbox" checked={val.ISACTIVE == "Y"} onClick={(e) => this.statusChange(e, val)} />
                                        <span class="slider round"></span>
                                    </label>
                                    <p class="m-0 mr-4 font-regular font-14">{val.ISACTIVE == "Y" ? "Active" : "Inactive"}</p>
                                    <div class="dropdown">
                                        <button class="btn p-0" type="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <img src="images/menu-dropdown.svg" alt="menu Icon" />
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item d-flex align-items-center font-regular font-14 color-grey" href="#" onClick={(e) => this.editQues(e, val, index)} >
                                                <img src="images/pencil-edit-icon.svg" alt="edit-icon" class="mr-2 " />Edit</a>
                                            <a class="dropdown-item d-flex align-items-center font-regular font-14 color-grey" href="#" onClick={(e) => this.deleteQues(e, val)}>
                                                <img src="images/delete-icon-red.svg" alt="delete-icon" class="mr-2" />Delete</a>
                                        </div>
                                    </div>
                                </div> : null}
                        </div>
                        {this.bindOptions(val)}
                        <div class="d-flex w-100 float-left">
                            {val.MAXLENGTH != "" && val.MAXLENGTH != " " && val.MAXLENGTH != null && val.MAXLENGTH != undefined ? <p class="font-14 font-regular mr-4">The character limit is <span class="font-bold">{val.MAXLENGTH}</span></p> : null}
                            {val.MINNUMBER != "" && val.MINNUMBER != null && val.MINNUMBER != " " && val.MINNUMBER != undefined ? <p class="font-14 font-regular mr-4">Min Number: <span class="font-bold">{val.MINNUMBER}</span></p> : null}
                            {val.MAXNUMBER != "" && val.MAXNUMBER != null && val.MAXNUMBER != " " && val.MAXNUMBER != undefined ? <p class="font-14 font-regular mr-4">Max Number:  <span class="font-bold">{val.MAXNUMBER} </span></p> : null}
                        </div>

                    </div>
                )
            }
        })

    }
    cancel = () => {
      
        let quesArray = []
        if (this.state.quesArray && this.state.quesArray.length > 0) {
            quesArray = JSON.parse(JSON.stringify(this.state.quesArray));
        }
        else {
            quesArray = JSON.parse(JSON.stringify(this.state.tempQues));
            quesArray.splice(6);
        }
        this.setState({ tempQues: quesArray.sort((a, b) => a.QUESTIONNO > b.QUESTIONNO ? 1 : -1), allowSixUpload: 0, options: this.state.options, filteredOptions: [], hasChanges: false }, () => {
            // Callback function executes after state is updated
            this.findLastQuestion();
            this.findExistingUploads();
        });
    }
    saveForm = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
       
        let locOption = []
        let quesNos = []
        this.state.tempQues.map((val, index) => {
            val.FORMNAME = this.state.formName;
            quesNos.push(val.QUESTIONNO)
        })
        quesNos = quesNos.sort((a, b) => a < b ? -1 : 1)
        let i = 0;
     
        this.state.tempQues.forEach((x, index) => {
            let ques = quesNos[i]
            this.state.tempOption.forEach((y, ind) => {
                if (x.QUESTIONNO == y.QUESTIONNO) {
                    let BO = {
                        FORMNAME: y.FORMNAME,
                        ISDELETE: y.ISDELETE,
                        OPTIONNO: y.OPTIONNO,
                        OPTIONS: y.OPTIONS,
                        QUESTIONNO: ques
                    }
                    locOption.push(BO)
                }
            })
            x.QUESTIONNO = ques
            i = i + 1;
        })
        
        this.setState({ quesArray: this.state.tempQues, options: locOption })
        let saveFormBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            question: this.state.tempQues,
            options: locOption
        }
        ManageFormAction.saveForm(saveFormBO);
    }
    saveImg = () => {
        
        let validationFlag = true;
        let filteredOptions = this.state.filteredOptions.filter((val) => val.ISDELETE == "N")
        if (this.state.question == undefined && this.state.question == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter question"
            });
            validationFlag = false
        } else if (this.state.question.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please enter question"
            });
            validationFlag = false
        } else if (this.state.cntrlType == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select the control type"
            });
            validationFlag = false
        } else if (this.state.cntrlType.toLowerCase() == "choice" || this.state.cntrlType.toLowerCase() == "check" || this.state.cntrlType.toLowerCase() == "dropdown") {
            if (filteredOptions == undefined || filteredOptions == null || filteredOptions == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter options"
                });
                validationFlag = false
            } else {
                if (filteredOptions != undefined && filteredOptions != null && filteredOptions != "") {
                    filteredOptions.map((val, index) => {
                        if (val.OPTIONS.trim() == "" && val.ISDELETE.trim() != "Y") {
                            swal({
                                allowOutsideClick: false,
                                closeOnClickOutside: false,
                                text: "Please enter options"
                            });
                            validationFlag = false
                        }
                    })
                }
            }
            if (validationFlag) {
                if (this.state.cntrlType.toLowerCase() == "choice" && filteredOptions.length == 1) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please add another option for radio control"
                    });
                    validationFlag = false
                }

            }
        } else if (this.state.cntrlType.toLowerCase() == "text" || this.state.cntrlType.toLowerCase() == "textarea") {
            if (this.state.characterLimit == null || this.state.characterLimit == undefined || this.state.characterLimit == "" || this.state.characterLimit == " ") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter the character limit"
                });
                validationFlag = false
            }
        }
        else if (this.state.cntrlType.toLowerCase() == "number") {
            if (this.state.maxNumber == "" || this.state.maxNumber == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter maximum and minumum number"
                });
                validationFlag = false
            } else if (parseInt(this.state.maxNumber) < parseInt(this.state.minNumber)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Maximum number should not be lesser than minimum number"
                });
                validationFlag = false
            } else if (parseInt(this.state.maxNumber) == parseInt(this.state.minNumber)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Minimum and Maximum number should not be the same"
                });

                validationFlag = false
            }
        } if (this.state.isAdditionalInfo == true) {
            if (this.state.isAddText && (this.state.additionalInfotext == "" || this.state.additionalInfotext == undefined || this.state.additionalInfotext == null)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please enter additional information"
                });
                validationFlag = false
            } else if (this.state.isAddText && this.state.additionalInfotext != null && this.state.additionalInfotext != undefined && this.state.additionalInfotext != "") {
                if (this.state.additionalInfotext.trim() == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter additional information"
                    });
                    validationFlag = false
                }
            } else if (this.state.isAddImage && this.state.attachment == "") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please upload image"
                });
                validationFlag = false
            }
        } if (validationFlag) {
            if (this.state.tempQues != undefined && this.state.tempQues != null && this.state.tempQues != []) {
                let duplicateQues = 0;
                let currIndex = this.state.tempQues.findIndex(y => y.QUESTIONNO == this.state.currentQues)
                this.state.tempQues.map((ques, index) => {
                    if (index != this.state.quesIndex && ques.QUESTIONS.trim().toLowerCase() == this.state.question.trim().toLowerCase()) {

                        duplicateQues += 1;
                    }
                })
                if (duplicateQues > 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Questions cannot be repeated"
                    });
                    validationFlag = false

                }
                if (this.state.filteredOptions != undefined && this.state.filteredOptions != null && this.state.filteredOptions != []) {
                    let unDeletedOptions = this.state.filteredOptions.filter((val, ind) => val.ISDELETE == "N")
                    let filteredOptions = unDeletedOptions.filter((ele, ind) => ind === unDeletedOptions.findIndex(elem => elem.OPTIONS.toLowerCase() === ele.OPTIONS.toLowerCase()))
                    if (filteredOptions.length != unDeletedOptions.length) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: "Options cannot be repeated"
                        });
                        validationFlag = false
                    }
                }
            }
        }
        if (validationFlag) {
            if (this.state.attachment.length > 0) {
                let rex = SDIConstants.urlregexp;
                let additionalinfoStr = this.state.attachment[0].FilePath
                if (!rex.test(additionalinfoStr)) {
                    let attachmentBO = {
                        Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                        Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                        attachment: this.state.attachment
                    }
                    $('#add-question').modal('hide');
                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    ManageFormAction.saveAttachment(attachmentBO);
                }
                else {
                    $('#add-question').modal('hide');
                    this.setState({ hasChanges: true });
                    this.saveQues()
                }
            } else {
                $('#add-question').modal('hide');
                this.setState({ hasChanges: true });
                this.saveQues()
            }
        }
    }
    saveQues = () => {
      
        let addLabel = this.state.addLabel
        let addDesc = this.state.addDesc
        if (addLabel != undefined && addLabel != null) {
            addLabel = addLabel.trim();
        }
        if (addDesc != undefined && addDesc != null) {
            addDesc = addDesc.trim();
        }
        if (this.state.formType == "add" || this.state.isAddclick) {
            let tempques = this.state.tempQues
            let localArray = {
                FORMNAME: this.state.formName,
                QUESTIONNO: this.state.currentQues,
                QUESTIONS: this.state.question,
                MANDATORY: (this.state.isMandatoryField ? "Y" : "N"),
                TYPE: this.state.cntrlType,
                MAXLENGTH: this.state.characterLimit,
                ISACTIVE: (this.state.isActive ? "Y" : "N"),
                PREFILLTEXT: this.state.prefillText,
                ADDITIONALINFO: (this.state.isAdditionalInfo && this.state.additionalInfotext != undefined && this.state.additionalInfotext != null ? this.state.additionalInfotext.trim() : ""),
                ISADDIMAGE: (this.state.isAdditionalInfo ? this.state.isAddImage : false),
                ATTACHMENT_FILE_NAME: (this.state.isAdditionalInfo && this.state.isAddImage ? this.state.attachment[0].FileName : ""),
                ATTACHMENT: (this.state.isAdditionalInfo && this.state.isAddImage ? this.state.attachment[0].FilePath : ""),
                ATTACHMENT_LABEL: (this.state.isAdditionalInfo ? addLabel : ""),
                ATTACHMENT_DESC: (this.state.isAdditionalInfo ? addDesc : ""),
                MINNUMBER: this.state.minNumber,
                MAXNUMBER: this.state.maxNumber,
                PLACEHOLDERTEXT: this.state.placeHolderText,
                ISDELETE: "N"

            }
            tempques.push(localArray)
         
            let optiontemp = JSON.parse(JSON.stringify(this.state.tempOption));

            if (this.state.cntrlType.toLowerCase() == "attachment") {
                this.setState({ allowSixUpload: this.state.allowSixUpload + 1 })
            }
            this.setState({
                tempQues: tempques.sort((a, b) => a.QUESTIONNO > b.QUESTIONNO ? 1 : -1), options: optiontemp,
                placeHolderText: "",
                prefillText: "",
                characterLimit: "",
                additionalInfotext: "",
                attachment: [], addLabel: "", addDesc: "",
                minNumber: "",
                maxNumber: "",
                isActive: true,
                isAdditionalInfo: false,
                isMandatoryField: false, isAddImage: false,
                isAddText: true,
                cntrlType: "", question: "", filteredOptions: [],
                showInfo: true, hasChanges: true
            })
        } else if (this.state.formType == "edit") {
            let ques = this.state.tempQues;
            let optiontemp = JSON.parse(JSON.stringify(this.state.tempOption));
            let index = ques.findIndex(y => y.QUESTIONNO == this.state.currentQues);
            let changeEdit = ques[index].TYPE.toLowerCase() == "attachment";
            ques[index].QUESTIONS = this.state.question
            ques[index].ADDITIONALINFO = (this.state.isAdditionalInfo && this.state.additionalInfotext != undefined && this.state.additionalInfotext != null ? this.state.additionalInfotext.trim() : "")
            ques[index].ISADDIMAGE = (this.state.isAdditionalInfo ? this.state.isAddImage : false)
            ques[index].ATTACHMENT_FILE_NAME = (this.state.isAdditionalInfo && this.state.isAddImage ? this.state.attachment[0].FileName : "")
            ques[index].ATTACHMENT = (this.state.isAdditionalInfo && this.state.isAddImage ? this.state.attachment[0].FilePath : "")
            ques[index].ATTACHMENT_LABEL = (this.state.isAdditionalInfo ? addLabel : "")
            ques[index].ATTACHMENT_DESC = (this.state.isAdditionalInfo ? addDesc : "")
            ques[index].TYPE = this.state.cntrlType
            ques[index].MAXLENGTH = this.state.characterLimit
            ques[index].PLACEHOLDERTEXT = this.state.placeHolderText
            ques[index].PREFILLTEXT = this.state.prefillText
            ques[index].MINNUMBER = this.state.minNumber
            ques[index].MAXNUMBER = this.state.maxNumber
            ques[index].MANDATORY = (this.state.isMandatoryField == true ? "Y" : "N")
            ques[index].ISACTIVE = (this.state.isActive == true ? "Y" : "N")


            if (!changeEdit && this.state.cntrlType.toLowerCase() == "attachment") {
                this.setState({ allowSixUpload: this.state.allowSixUpload + 1 })
            }
            if (changeEdit && this.state.cntrlType.toLowerCase() != "attachment") {
                this.setState({ allowSixUpload: this.state.allowSixUpload - 1 })
            }
            this.setState({
                tempQues: ques, placeHolderText: "",
                prefillText: "",
                characterLimit: "",
                additionalInfotext: "",
                attachment: [], addLabel: "", addDesc: "",
                minNumber: "",
                maxNumber: "",
                isActive: true,
                isAddImage: false,
                isAddText: true,
                isAdditionalInfo: false,
                isMandatoryField: false,
                cntrlType: "",
                filteredOptions: [], question: "", options: optiontemp,
                showInfo: true
            })
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    cancelQues = () => {
        $('#add-question').modal('hide');
        let options = JSON.parse(JSON.stringify(this.state.options));

        if (this.state.quesType == "add") { // WW-967 , To avoid unwanted skipping of numbers, Divis Kumar R K
            let currentQues = this.state.currentQues
            currentQues = currentQues - 1
            this.setState({ currentQues: currentQues })
        }
        this.setState({
            placeHolderText: "",
            prefillText: "",
            characterLimit: "",
            additionalInfotext: "",
            attachment: [], addLabel: "", addDesc: "",
            minNumber: "",
            maxNumber: "",
            isActive: true,
            isAdditionalInfo: false,
            isMandatoryField: false, isAddImage: false,
            isAddText: true,
            cntrlType: "", question: "", filteredOptions: [], tempOption: options,
            showInfo: true, lblerror: "", hasChanges: false
        })
        this.findLastQuestion();
    }
    handleQues = (type, e) => {
        
        switch (type) {
            case 1: {
                this.setState({ question: e.target.value })
                break;
            } case 2: {
                let isAdditionalInfo = this.state.isAdditionalInfo
                this.setState({ isAdditionalInfo: !isAdditionalInfo })
                break;
            }
            case 3: {
                let isActive = this.state.isActive
                this.setState({ isActive: !isActive })
                break;
            }
            case 4: {
                this.setState({ placeHolderText: e.target.value })
                break;
            }
            case 5: {
                this.setState({ prefillText: e.target.value })
                break;
            }
            case 6: {
                let re = SDIConstants.quantityRegEX;
                if (re.test(e.target.value) || e.target.value == "") {
                    let maxLength = parseInt(e.target.value);
                    if ((maxLength < 255 || e.target.value == "") && maxLength != 0) {
                        this.setState({ characterLimit: e.target.value })
                    }
                }
                break;
            }
            case 7: {
                let isMandatoryField = this.state.isMandatoryField
                this.setState({ isMandatoryField: !isMandatoryField })
                break;
            }

            case 8: {
                this.setState({ additionalInfoText: e.target.value })
                break;
            }
            case 9: {
                let re = SDIConstants.numberRegEX;
                let minNumber = this.state.minNumber
                if (re.test(e.target.value) || e.target.value == "") {
                    let maxLength = parseInt(e.target.value);
                    if (maxLength < 1001 || e.target.value == "") {
                        if (e.target.value == "0") {
                            minNumber = "0"
                        }
                        else {
                            minNumber = e.target.value.replace(/^0+/, '');
                        }
                        if (minNumber.includes(".")) {
                            let textLimit = minNumber.slice(0, (minNumber.indexOf(".")) + 4);
                            if (textLimit.split(".")[0] == "") {
                                minNumber = "0" + textLimit
                            }
                            else {
                                minNumber = textLimit
                            }
                        }
                        this.setState({ minNumber: minNumber })
                    }
                }
                break;
            }
            case 10: {
                let re = SDIConstants.numberRegEX;
                let maxnumber = this.state.maxNumber
                if (re.test(e.target.value) || e.target.value == "") {
                    let maxLength = parseInt(e.target.value);
                    if (maxLength < 1001 || e.target.value == "") {
                        if (e.target.value == "0") {
                            maxnumber = "0"
                        }
                        else {
                            maxnumber = e.target.value.replace(/^0+/, '');
                        }
                        if (maxnumber.includes(".")) {
                            let textLimit = maxnumber.slice(0, (maxnumber.indexOf(".")) + 4);
                            if (textLimit.split(".")[0] == "") {
                                maxnumber = "0" + textLimit
                            }
                            else {
                                maxnumber = textLimit
                            }
                        }
                        this.setState({ maxNumber: maxnumber })
                    }
                }
            }
        }
    }
    onChooseCntrl = (type, value) => {
        //Regression bug - 5277 - Yuvarani K
        this.setState({ lblerror: "" })
        let filteredOptions = []
        let maxOption = 0
        let filteredTemp = this.state.tempOption.filter((item) => item.QUESTIONNO == this.state.currentQues && item.FORMNAME == this.state.formName)
        if (filteredTemp.length > 0) {
            maxOption = filteredTemp.reduce((p, c) => p.OPTIONNO > c.OPTIONNO ? p : c);
        }
        let localArray = {
            FORMNAME: this.state.formName,
            QUESTIONNO: this.state.currentQues,
            OPTIONS: "",
            OPTIONNO: (filteredTemp.length > 0 ? maxOption.OPTIONNO + 1 : 0),
            ISDELETE: "N"
        }
        filteredOptions.push(localArray);
        let tempOption = this.state.tempOption;
        tempOption.map((val, index) => {
            if (val.QUESTIONNO == this.state.currentQues) {
                val.ISDELETE = "Y"
            }
        })
        if (type == 1 || type == 2 || type == 5) {
            tempOption.push(localArray)
        }


        if (type == 7) {
            this.setState({ showInfo: false })
        }
        else {
            this.setState({ showInfo: true })
        }

        $('#Opt-0').focus();
        this.setState({
            cntrlType: value,
            placeHolderText: "",
            prefillText: "",
            characterLimit: "",
            minNumber: "",
            maxNumber: "",
            filteredOptions: filteredOptions,
            tempOption: tempOption
        })

    }
    manageFormNavigation = (e) => {
        e.preventDefault()
        this.props.history.push({ pathname: "/manageforms" })
    }
    handleFormName = (e) => {
        let formName = e.target.value;       
        if (formName) {
            let questionOptions = JSON.parse(JSON.stringify(this.state.tempQues)); 
            if (questionOptions && questionOptions.length == 0){
                 questionOptions = [{
                    "ADDITIONALINFO": "",
                    "ATTACHMENT": "",
                    "ATTACHMENT_DESC": "",
                    "ATTACHMENT_FILE_NAME": "",
                    "ATTACHMENT_LABEL": "",
                    "FORMNAME": formName,
                    "ISACTIVE": "Y",
                    "ISADDIMAGE": false,
                    "ISDELETE": "N",
                    "MANDATORY": "Y",
                    "MAXLENGTH": "70",
                    "MAXNUMBER": "",
                    "MINNUMBER": "",
                    "PLACEHOLDERTEXT": "Enter technician name",
                    "PREFILLTEXT": "",
                    "QUESTIONNO": 1,
                     "QUESTIONS": "Technician name",
                    "TYPE": "Text"
                 },
                     {
                         "ADDITIONALINFO": "",
                         "ATTACHMENT": "",
                         "ATTACHMENT_DESC": "",
                         "ATTACHMENT_FILE_NAME": "",
                         "ATTACHMENT_LABEL": "",
                         "FORMNAME": formName,
                         "ISACTIVE": "Y",
                         "ISADDIMAGE": false,
                         "ISDELETE": "N",
                         "MANDATORY": "Y",
                         "MAXLENGTH": "12",
                         "MAXNUMBER": "",
                         "MINNUMBER": "",
                         "PLACEHOLDERTEXT": "Enter technician phone number",
                         "PREFILLTEXT": "",
                         "QUESTIONNO": 2,
                         "QUESTIONS": "Technician phone number",
                         "TYPE": "Text"
                     },
                     {
                         "ADDITIONALINFO": "",
                         "ATTACHMENT": "",
                         "ATTACHMENT_DESC": "",
                         "ATTACHMENT_FILE_NAME": "",
                         "ATTACHMENT_LABEL": "",
                         "FORMNAME": formName,
                         "ISACTIVE": "Y",
                         "ISADDIMAGE": false,
                         "ISDELETE": "N",
                         "MANDATORY": "Y",
                         "MAXLENGTH": "60",
                         "MAXNUMBER": "",
                         "MINNUMBER": "",
                         "PLACEHOLDERTEXT": "Enter technician email address",
                         "PREFILLTEXT": "",
                         "QUESTIONNO": 3,
                         "QUESTIONS": "Technician email address",
                         "TYPE": "Text"
                     },
                     {
                         "ADDITIONALINFO": "",
                         "ATTACHMENT": "",
                         "ATTACHMENT_DESC": "",
                         "ATTACHMENT_FILE_NAME": "",
                         "ATTACHMENT_LABEL": "",
                         "FORMNAME": formName,
                         "ISACTIVE": "Y",
                         "ISADDIMAGE": false,
                         "ISDELETE": "N",
                         "MANDATORY": "Y",
                         "MAXLENGTH": "9",
                         "MAXNUMBER": "",
                         "MINNUMBER": "",
                         "PLACEHOLDERTEXT": "Enter work order number",
                         "PREFILLTEXT": "",
                         "QUESTIONNO": 4,
                         "QUESTIONS": "Work order number",
                         "TYPE": "Text"
                     },
                     {
                         "ADDITIONALINFO": "",
                         "ATTACHMENT": "",
                         "ATTACHMENT_DESC": "",
                         "ATTACHMENT_FILE_NAME": "",
                         "ATTACHMENT_LABEL": "",
                         "FORMNAME": formName,
                         "ISACTIVE": "Y",
                         "ISADDIMAGE": false,
                         "ISDELETE": "N",
                         "MANDATORY": "Y",
                         "MAXLENGTH": "6",
                         "MAXNUMBER": "",
                         "MINNUMBER": "",
                         "PLACEHOLDERTEXT": "",
                         "PREFILLTEXT": "W",
                         "QUESTIONNO": 5,
                         "QUESTIONS": "Install store",
                         "TYPE": "Text"
                     },
                     {
                         "ADDITIONALINFO": "",
                         "ATTACHMENT": "",
                         "ATTACHMENT_DESC": "",
                         "ATTACHMENT_FILE_NAME": "",
                         "ATTACHMENT_LABEL": "",
                         "FORMNAME": formName,
                         "ISACTIVE": "Y",
                         "ISADDIMAGE": false,
                         "ISDELETE": "N",
                         "MANDATORY": "Y",
                         "MAXLENGTH": "",
                         "MAXNUMBER": "99999",
                         "MINNUMBER": "1",
                         "PLACEHOLDERTEXT": "",
                         "PREFILLTEXT": "",
                         "QUESTIONNO": 6,
                         "QUESTIONS": "Quantity",
                         "TYPE": "Number"
                     }
                ];
            }
            
            this.setState({ tempQues: questionOptions, lastQuestion: 6 });
        }
        this.setState({ formName: formName })
    }
    addQues = () => {
        //debugger
        if (this.state.formType == "add") {
            let index = this.state.formDetail.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == this.state.formName.toLowerCase().trim().split(/ +/).join(' '))
            if (index > -1) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Form Name already exists"
                });
            } else {
                $('#add-question').modal('show');
            }
        } else {
            $('#add-question').modal('show');
        }
        if (this.state.allowSixUpload >= 6) {
            this.setState({ disableBtn: true, showInfo: false })
        }
        else {
            this.setState({ disableBtn: false, showInfo: true })
        }

        this.setState({ isAddclick: true, quesType: "Add Question", currentQues: this.state.lastQuestion + 1, quesIndex: this.state.lastQuestion + 1, lastQuestion: this.state.lastQuestion + 1 })
    }
    handleOptions = (type, index, e) => {
        //debugger
        console.log("opt", this.state.options)
        e.preventDefault()
        let filteredOptions = this.state.filteredOptions;
        let tempOption = this.state.tempOption
        let maxOption = 0
        let filteredTemp = tempOption.filter((item) => item.QUESTIONNO == this.state.currentQues && item.FORMNAME == this.state.formName)
        if (filteredTemp.length > 0) {
            maxOption = filteredTemp.reduce((p, c) => p.OPTIONNO > c.OPTIONNO ? p : c);
        }
        if (type == 1) {
            filteredOptions[index].OPTIONS = e.target.value
            let tempIndex = tempOption.findIndex(y => y.FORMNAME == filteredOptions[index].FORMNAME && y.QUESTIONNO == filteredOptions[index].QUESTIONNO && y.OPTIONNO == filteredOptions[index].OPTIONNO);

            if (tempIndex > -1) {
                tempOption[tempIndex].OPTIONS = e.target.value
            } else {
                let localArray = {
                    FORMNAME: this.state.formName,
                    QUESTIONNO: this.state.currentQues,
                    OPTIONS: e.target.value,
                    OPTIONNO: (filteredTemp.length > 0 ? maxOption.OPTIONNO + 1 : 0),
                    ISDELETE: "N"
                }
                tempOption.push(localArray);
            }
        } else if (type == 2) {
            this.cursor = e.target.selectionStart;
            let localArray = {
                FORMNAME: this.state.formName,
                QUESTIONNO: this.state.currentQues,
                OPTIONS: e.target.value,
                OPTIONNO: (filteredTemp.length > 0 ? maxOption.OPTIONNO + 1 : 0),
                ISDELETE: "N"
            }
            filteredOptions.push(localArray);
            tempOption.push(localArray);
            this.setState({ inputtext: e.target.value })
        } else {
            if (filteredOptions != undefined && filteredOptions != null && filteredOptions != [] && filteredOptions != "") {
                filteredOptions[index].ISDELETE = "Y"
                let tempIndex = tempOption.findIndex(y => y.FORMNAME == filteredOptions[index].FORMNAME && y.QUESTIONNO == filteredOptions[index].QUESTIONNO && y.OPTIONNO == filteredOptions[index].OPTIONNO);
                if (tempIndex > -1) {
                    tempOption[tempIndex].ISDELETE = "Y"
                }
            }

        }
        this.setState({ filteredOptions: filteredOptions, tempOption: tempOption, hasChanges: true })
    
    }
    handleAttachmentImg = (event) => {
        
        let file = event.target.files;
        let lblerror = ""
        if (this.state.attachment.length == 0) {
            if (!file[0].name.toLowerCase().includes(".jpeg") && !file[0].name.toLowerCase().includes(".jpg") && !file[0].name.toLowerCase().includes(".png")) {
                lblerror = "Please upload files in supported formats such as JPG, SVG, JPEG, and PNG"
            } else {
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ManageFormAction.addAttachment(file);
            }
        } else {
            lblerror = "You can upload only one image"
        }
        this.setState({ lblerror: lblerror })
    }
    addOptions = (e) => {
        
        e.preventDefault()
        let filteredOptions = this.state.filteredOptions;
        let maxOption = 0
        let tempOption = this.state.tempOption
        let filteredTemp = tempOption.filter((item) => item.QUESTIONNO == this.state.currentQues && item.FORMNAME == this.state.formName)
        if (filteredTemp.length > 0) {
            maxOption = filteredTemp.reduce((p, c) => p.OPTIONNO > c.OPTIONNO ? p : c);
        }
        let localArray = {
            FORMNAME: this.state.formName,
            QUESTIONNO: this.state.currentQues,
            OPTIONS: "",
            OPTIONNO: (filteredTemp.length > 0 ? maxOption.OPTIONNO + 1 : 0),
            ISDELETE: "N"
        }
        let tempOptionArray = {
            FORMNAME: this.state.formName,
            QUESTIONNO: this.state.currentQues,
            OPTIONS: "",
            OPTIONNO: (filteredTemp.length > 0 ? maxOption.OPTIONNO + 1 : 0),
            ISDELETE: "N"
        }
        filteredOptions.push(localArray);
        tempOption.push(tempOptionArray);
        $(`Opt-${filteredOptions.length - 1}`).focus();
        this.setState({ filteredOptions: filteredOptions, tempOption: tempOption })
    }
    bindQues = (type) => {
        let options = this.state.filteredOptions
        return options.map((val, index) => {
            if (val.ISDELETE.toLowerCase() != "y") {
                switch (type) {
                    case 1: {
                        return (

                            <div class=" w-100 align-items-center d-flex mb-2">
                                <span class="pr-2"><img src="images/choice-indication.svg" alt="choice-indication" /></span>
                                <label class="form-check-label w-100 float-left">
                                    <input type="text" class="form-control  w-50 float-left choice-txtbox" maxLength="254" autofocus="on" id={`Opt-${index}`} value={val.OPTIONS} onChange={(e) => this.handleOptions(1, index, e)} />
                                    <a href="#" title="Clear" onClick={(e) => this.handleOptions(3, index, e)}><img class="pl-2 pt-2 float-left" src="images/close-form.svg"
                                        alt="close-icon" /></a>
                                </label>
                            </div>
                        )
                        break;

                    } case 2: {
                        return (
                            <div class=" w-100 align-items-center d-flex mb-2">
                                <span class="pr-2"><img src="images/check-indication.svg" alt="check-indication" /></span>
                                <label class="form-check-label w-100 float-left">
                                    <input type="text" class="form-control  w-50 float-left choice-txtbox" autofocus="on" id={`Opt-${index}`} maxLength="254" value={val.OPTIONS} onChange={(e) => this.handleOptions(1, index, e)} />
                                    <a href="#" title="Clear" onClick={(e) => this.handleOptions(3, index, e)}><img class="pl-2 pt-2 float-left" src="images/close-form.svg"
                                        alt="close-icon" /></a>
                                </label>
                            </div>
                        )
                        break;
                    } case 3: {
                        return (
                            <div class=" w-100 align-items-center d-flex mb-2">
                                <label class="form-check-label w-100 float-left">
                                    <input type="text" class="form-control  w-50 float-left choice-txtbox rounded-0" autofocus="on" maxLength="254"
                                        value={val.OPTIONS} onChange={(e) => this.handleOptions(1, index, e)} id={`Opt-${index}`} />
                                    <a href="#" title="Clear" onClick={(e) => this.handleOptions(3, index, e)}><img class="pl-2 pt-2 float-left" src="images/close-form.svg"
                                        alt="close-icon" /></a>
                                </label>
                            </div>
                        )
                        break;
                    }
                }
            }

        })
    }
    downloadAttachment = (e, attachment) => {
        let downloadBO = {
            fileName: attachment[0].FileName,
            filePath: attachment[0].FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ManageFormAction.downloadAttachment(downloadBO);
    }
    removeAttachments = (type, filepath) => {
        if (type == "url") {
            let tempAttachments = this.state.attachment;
            tempAttachments.splice(0, 1);
            this.setState({ attachment: tempAttachments, lblerror: "" });
        } else {
            let removeBO = {
                filePath: filepath
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ManageFormAction.removeAttachment(removeBO);
        }

    }
    //when we tried to add the same file for the second time its not inserting
    onInputClick = (event) => {
        event.target.value = ''
    }
    bindAttachments = () => {
       
        let attachment = this.state.attachment
        if (attachment != undefined) {
            if (attachment.length != 0) {
                let rex = SDIConstants.urlregexp;
                if (!rex.test(attachment[0].FilePath)) {
                    return (
                        <div className="attachment-file-name ml-2">
                            <a className="Attachment-overflow col-4 p-0" data-toggle="tooltip" title={attachment[0].FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment[0].FileName}
                            </a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments("nonurl", attachment[0].FilePath)}>X</span>

                        </div>
                    )
                } else {
                    return (
                        <div className="attachment-file-name ml-2">
                            <a className="Attachment-overflow p-0 col-4 p-0" href={attachment[0].FilePath} data-toggle="tooltip" target="_blank" title={attachment[0].FileName}>{attachment[0].FileName}
                            </a>
                            <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments("url", attachment[0].FilePath)}>X</span>
                        </div>
                    )
                }

            }
        }

    };
    render() {
        const { t } = this.props;
        let isDeletecount = 0
        this.state.tempQues.map((item, index) => {
            if (item.ISDELETE.toLowerCase() == "y") {
                isDeletecount = isDeletecount + 1
            }
        })

        return (
            <div class="container-fluid content-section" style={{ marginTop: "157px" }}>
                <div class="row">

                    {/*<!-- edit forms starts here -->*/}
                    <div class="container-fluid content-margin">
                        <div class="row">
                            <div class="col-md-12 page-heading mb-3">
                                <h5 class="page-title"><span class="pr-2"><a href="#" title="Back" onClick={(e) => this.manageFormNavigation(e)}><img src="images/arrow-1.svg" alt="logo" /></a></span>{this.state.formAction}</h5>
                            </div>
                            <div class="col-md-12 float-left">
                                <div class="w-100 float-left mb-5">
                                    <div class="col-md-4 mt-4 float-left">
                                        <label class="sa-formlabbel" for="formName">Form Name
                  <span class="info-container">
                                                <img className="info-question" src="images/question-info.svg" alt="Info-icon" />
                                                <span className="Grid-info-icon text-left" style={{ width: "301px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>Form name should match the attribute value of the item</span>
                                            </span>

                                        </label>
                                        {this.state.formAction.toLowerCase().trim() == "add form" ?
                                            <input type="text" id="formName" class="form-control mr-5" value={this.state.formName} onChange={(e) => this.handleFormName(e)} maxLength="254" /> :
                                            <div><label class="sa-formlabbel">{this.state.formName}</label></div>}

                                    </div>

                                </div>

                                <div class="w-100 float-left px-3">
                                    <div class="w-100 float-left ">
                                        {this.state.formName.trim() != "" && this.state.tempQues != undefined && this.state.tempQues != null && this.state.tempQues != "" && this.state.tempQues != [] && (isDeletecount != this.state.tempQues.length) ?
                                            <h5 class="col-md-12 float-left font-bold font-20 pl-0">Questions</h5> :
                                            null}
                                        {this.state.formType != "view" && this.state.formName.trim() != "" ?
                                            <div style={{ marginBottom: "38px" }}>
                                                <span class="font-14 font-regular my-0 mb-4">
                                                    <span class="info-container pr-1"><img src="images/info-black-icon.svg" alt="Info-icon" /></span>
                                                    Please click "Add Question" button to add a new question
                                           </span>
                                                <button type="button" class="btn btn-continue ml-3 float-right" data-toggle="modal"
                                                    onClick={() => this.addQues()}><img src="images/plus-icon-black.svg" alt="plus" class="mr-1" />Add Question</button> </div> : null}
                                        {this.state.formType == "view" ?
                                            <button type="button" class="btn btn-continue ml-3 float-right mb-3" data-toggle="modal" onClick={() => this.setState({ formType: "edit", formAction: "Edit Form" })}><img src="images/edit-btn-icon.svg" alt="plus" class="mr-1" />Edit</button> : null}
                                    </div>

                                </div>
                                {/*<!--Question webpart end-->*/}

                                {/* <!--Slider start here-->*/}
                                <div class="modal fade " id="add-question" tabindex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                                    <div class="modal-dialog-addques modal-dialog modal-add-question modal-slider modal-dialog-scrollable">
                                        <div class="modal-content  modal-custom-height">
                                            <div class="modal-header border-0 pb-2">
                                                <h5 class="modal-title pl-3  font-24 font-bold">{this.state.quesType}</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={() => this.cancelQues()}>
                                                    <img src="images/close-modal.svg" alt="close" />
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="col-md-12 mb-4 float-left">
                                                    <label class="sa-formlabbel" for="question">Question<span class="required-red">*</span>
                                                    </label>
                                                    <textarea class="form-control" id="question" rows="3" value={this.state.question} maxLength="254" onChange={(e) => this.handleQues(1, e)}></textarea>
                                                </div>
                                                <div class="col-md-12 mb-4 float-left">
                                                    <label class="sa-formlabbel">Is there any additional information?
                      </label>
                                                    <div class="custom-control custom-switch ml-2 mb-2 d-inline">
                                                        <input type="checkbox" class="custom-control-input yellow-bg-switch" data-toggle="modal" id="customSwitch1" checked={this.state.isAdditionalInfo} onChange={(e) => this.handleQues(2, e)} />
                                                        <label class="custom-control-label" for="customSwitch1">{this.state.isAdditionalInfo ? "Yes" : "No"}</label>
                                                    </div>
                                                    {this.state.isAdditionalInfo ?
                                                        <div class="col-md-12 px-1 mb-3">
                                                            <label className="custom-radiobtn mr-2 my-2">Text Box
                                                            <input type="radio" id="additionalText" onChange={() => this.setState({ isAddText: true, isAddImage: false, attachment: [], addLabel: "", addDesc: "" })} name="radio" checked={this.state.isAddText} />
                                                                <span className="checkmark checkmark-org" />
                                                            </label>
                                                            <label className="custom-radiobtn mr-2 my-2">Image Upload
                                                            <input type="radio" id="additionalImage" onChange={() => this.setState({ isAddText: false, isAddImage: true, additionalInfotext: "" })} name="radio" checked={this.state.isAddImage} />
                                                                <span className="checkmark checkmark-org" />
                                                            </label>
                                                        </div>
                                                        : null}
                                                    {this.state.isAdditionalInfo && this.state.isAddText == true ?
                                                        <div class="col-md-12 px-1 mb-3">
                                                            <input type="text" class="form-control slider-txtbox" id="addText" placeholder="Enter Additional Information" onChange={(e) => this.setState({ additionalInfotext: e.target.value })} value={this.state.additionalInfotext} maxLength="254" />
                                                        </div> : null}
                                                    {this.state.isAdditionalInfo && this.state.isAddImage == true ?
                                                        <div>
                                                            <div className="d-flex mb-3 align-items-center">
                                                                <div class="browse-btn">
                                                                    <button type="button" class="font-medium font-12 browsefile-btn d-flex flex-row align-items-center">
                                                                        <img src="Images/upload.svg" alt="upload" class="mr-2" /> Upload
                                                                </button>
                                                                    <input type="file" name="myfile" id="fileUpload" accept="image/jpg, image/svg, image/jpeg, image/png" onChange={this.handleAttachmentImg} onClick={this.onInputClick} />
                                                                </div>
                                                                {this.bindAttachments()}
                                                            </div>
                                                            <label className="priority-alert" id="lblerror">{this.state.lblerror}</label>
                                                            <div>
                                                                <input type="text" class="form-control slider-txtbox mb-2" id="addLabel" onChange={(e) => this.setState({ addLabel: e.target.value })} placeholder="Enter label(optional)" value={this.state.addLabel} maxLength="30" />
                                                                <input type="text" class="form-control slider-txtbox" id="addDesc" onChange={(e) => this.setState({ addDesc: e.target.value })} placeholder="Enter description(optional)" value={this.state.addDesc} maxLength="254" />
                                                            </div>
                                                        </div>
                                                        : null}





                                                </div>

                                                {/*<!-- Choose form control starts  -->*/}
                                                <div class="col-md-12 mb-3 float-left">
                                                    <label class="sa-formlabbel mandatory-after">Choose form control</label>
                                                    <div class="w-100 float-left">
                                                        {this.state.cntrlType.toLowerCase() == "check" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(1, "Check")}><img class="mr-2 mt-1" src="images/check-icon.svg"
                                                                alt="check-icon" />Check</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(1, "Check")}><img class="mr-2 mt-1" src="images/check-icon.svg"
                                                                alt="check-icon" />Check</button>}
                                                        {this.state.cntrlType.toLowerCase() == "choice" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(2, "Choice")} ><img class="mr-2 mt-1" src="images/choice-icon.svg"
                                                                alt="choice-icon" />Choice</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(2, "Choice")} ><img class="mr-2 mt-1" src="images/choice-icon.svg"
                                                                alt="choice-icon" />Choice</button>}
                                                        {this.state.cntrlType.toLowerCase() == "text" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(3, "Text")}><img class="mr-2 mt-1" src="images/text-icon.svg"
                                                                alt="text-icon" />Text</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(3, "Text")} ><img class="mr-2 mt-1" src="images/text-icon.svg"
                                                                alt="choice-icon" />Text</button>}
                                                        {this.state.cntrlType.toLowerCase() == "textarea" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(4, "Textarea")}><img class="mr-2 mt-1" src="Images/text-box.svg"
                                                                alt="textbox-icon" />Text area</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(4, "Textarea")} ><img class="mr-2 mt-1" src="images/text-box.svg"
                                                                alt="choice-icon" />Text area</button>}
                                                        {this.state.cntrlType.toLowerCase() == "dropdown" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(5, "Dropdown")} ><img class="mr-2 mt-1" src="images/dropdown-icon.svg"
                                                                alt="dropdown-icon" />Dropdown</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(5, "Dropdown")} ><img class="mr-2 mt-1" src="images/dropdown-icon.svg"
                                                                alt="dropdown-icon" />Dropdown</button>}
                                                        {this.state.cntrlType.toLowerCase() == "number" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(6, "Number")}><img class="mr-2" src="images/number-icon.svg"
                                                                alt="number-icon" />Number</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(6, "Number")}><img class="mr-2" src="images/number-icon.svg"
                                                                alt="number-icon" />Number</button>}
                                                        {this.state.cntrlType.toLowerCase() == "attachment" ?
                                                            <button class="btn btn-group float-left" style={{ backgroundColor: "#fff1d0" }} onClick={(e) => this.onChooseCntrl(7, "Attachment")} disabled={this.state.disableBtn}><img class="mr-2" src="images/img-icon.svg"
                                                                alt="number-icon" />Image</button> :
                                                            <button class="btn btn-group float-left" onClick={(e) => this.onChooseCntrl(7, "Attachment")} disabled={this.state.disableBtn}><img class="mr-2" src="images/img-icon.svg"
                                                                alt="number-icon" />Image</button>}
                                                    </div>
                                                </div>
                                                {/* <!-- Choose form control ends  -->
                    <!--Radio choice control start here-->*/}
                                                <div class="col-md-12 mb-3 float-left" hidden={this.state.showInfo}><span><img src="images/info-icon.png" /></span><span class="font-14 font-regular ml-2">Only six questions can be created with choose control as image and only one question can be uploaded against a question</span></div>

                                                {this.state.cntrlType.toLowerCase() == "choice" ?
                                                    <div class="col-md-12 mb-5 float-left">
                                                        <label class="sa-formlabbel ">Choices</label>
                                                        <div class="w-100 float-left">
                                                            {this.bindQues(1)}

                                                            <div class="w-100 float-left">
                                                                <a href="#"
                                                                    class="mt-2 text-secondary text-decoration-none d-flex align-items-center font-14 font-regular" maxLength="254" onClick={(e) => this.addOptions(e)}><img
                                                                        class="mr-2" src="images/add-icon-yellow.svg" alt="add icon" />Add Option</a>
                                                            </div>


                                                        </div>
                                                    </div> : null}
                                                {/* <!--Radio choice control end here-->
                    <!--check control start here-->*/}
                                                {this.state.cntrlType.toLowerCase() == "check" ?
                                                    <div class="col-md-12 mb-5 float-left">
                                                        <label class="sa-formlabbel ">Check</label>
                                                        <div class="w-100 float-left">
                                                            {this.bindQues(2)}

                                                            <div class="w-100 float-left">
                                                                <a href="#"
                                                                    class="mt-2 text-secondary text-decoration-none d-flex align-items-center font-14 font-regular" maxLength="254" onClick={(e) => this.addOptions(e)}><img
                                                                        class="mr-2" src="images/add-icon-yellow.svg" alt="add icon" />Add Option</a>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {/* <!--check choice control end here-->
                    <!--Text control start here-->*/}
                                                {this.state.cntrlType.toLowerCase() == "text" || this.state.cntrlType.toLowerCase() == "textarea" ?
                                                    <div class="col-md-12  float-left px-3">
                                                        {this.state.prefillText == " " || this.state.prefillText == "" ?
                                                            <div class="col-md-5 float-left px-1 mb-3">
                                                                <label class="sa-formlabbel " for="Placeholder-Text">Placeholder Text</label>
                                                                <span class="info-container">
                                                                    <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                    <span className="Grid-info-icon text-left" style={{ width: "225px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>The maximum character length is 50</span>
                                                                </span>

                                                                <input type="text" class="form-control slider-txtbox" id="Placeholder-Text"
                                                                    placeholder="Enter Placeholder Text" value={this.state.placeHolderText} maxLength="50" onChange={(e) => this.handleQues(4, e)} />
                                                            </div> : <div class="col-md-5 float-left px-1 mb-3">
                                                                <label class="sa-formlabbel " for="Placeholder-Text">Placeholder Text</label>
                                                                <span class="info-container">
                                                                    <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                    <span className="Grid-info-icon text-left" style={{ width: "225px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>The maximum character length is 50</span>
                                                                </span>

                                                                <input type="text" disabled class="form-control slider-txtbox" id="Placeholder-Text"
                                                                    placeholder="Enter Placeholder Text" value={this.state.placeHolderText} maxLength="50" onChange={(e) => this.handleQues(4, e)} />
                                                            </div>}
                                                        <div class="col-md-1 float-left px-1 ml-3" style={{ color: "grey", marginTop: "38px", fontSize: "14px" }}>(OR)</div>
                                                        {this.state.placeHolderText == "" || this.state.placeHolderText == " " ?
                                                            <div class="col-md-5 float-left px-1 mb-3">
                                                                <label class="sa-formlabbel " for="Prefill-Text">Default Prefill Text</label>
                                                                <span class="info-container">
                                                                    <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                    <span className="Grid-info-icon text-left" style={{ width: "225px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>The maximum character length is 20</span>
                                                                </span>
                                                                <input type="text" class="form-control slider-txtbox" id="Prefill-Text"
                                                                    placeholder="Enter Prefill Text" value={this.state.prefillText} maxLength="20" onChange={(e) => this.handleQues(5, e)} />
                                                            </div> : <div class="col-md-5 float-left px-1 mb-3">
                                                                <label class="sa-formlabbel " for="Prefill-Text">Default Prefill Text</label>
                                                                <span class="info-container">
                                                                    <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                    <span className="Grid-info-icon text-left" style={{ width: "225px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>The maximum character length is 20</span>
                                                                </span>
                                                                <input type="text" disabled class="form-control slider-txtbox" id="Prefill-Text"
                                                                    placeholder="Enter Prefill Text" value={this.state.prefillText} maxLength="20" onChange={(e) => this.handleQues(5, e)} />
                                                            </div>}
                                                        <div class="col-md-5 float-left px-1 mb-3">
                                                            <label class="sa-formlabbel " for="charecterLimit">Character Limit<span
                                                                class="required-red">*</span><a href="#" class="ml-1"></a></label>
                                                            <span class="info-container">
                                                                <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                <span className="Grid-info-icon text-left" style={{ width: "301px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>The maximum character limit for the answer is 254</span>
                                                            </span>
                                                            <input type="text" class="form-control slider-txtbox" id="charecterLimit"
                                                                placeholder="Enter your limit" value={this.state.characterLimit} onChange={(e) => this.handleQues(6, e)} />

                                                        </div>
                                                    </div> : null}
                                                {/*<!--Text control end here-->
                    <!--options control start here-->*/}
                                                {this.state.cntrlType.toLowerCase() == "dropdown" ?
                                                    <div class="col-md-12 mb-5 float-left">
                                                        <label class="sa-formlabbel ">Options</label>
                                                        <div class="w-100 float-left">
                                                            {this.bindQues(3)}
                                                            <div class="w-100 float-left">
                                                                <a href="#"
                                                                    class="mt-2 text-secondary text-decoration-none d-flex align-items-center font-14 font-regular" maxLength="254" onClick={(e) => this.addOptions(e)}><img
                                                                        class="mr-2" src="images/add-icon-yellow.svg" alt="add icon" />Add Option</a>
                                                            </div>
                                                        </div>
                                                    </div> : null}
                                                {/* <!--options control end here-->

                    <!--number control start here-->*/}
                                                {this.state.cntrlType.toLowerCase() == "number" ?
                                                    <div class="col-md-12  float-left px-3">

                                                        <div class="col-md-6 float-left px-1 mb-3">
                                                            <label class="sa-formlabbel " for="charecterLimitNum">Min Number<span
                                                                class="required-red">*</span></label>
                                                            <span class="info-container">
                                                                <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                <span className="Grid-info-icon text-left" style={{ width: "225px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>Minimum number allowed  is 0</span>
                                                            </span>
                                                            <input type="text" class="form-control slider-txtbox " min="0" id="charecterLimitNum"
                                                                placeholder="Enter Min Number" value={this.state.minNumber} onChange={(e) => this.handleQues(9, e)} />
                                                        </div>

                                                        <div class="col-md-6 float-left px-1 mb-3">
                                                            <label class="sa-formlabbel " for="charecterLimitMax">Max Number<span
                                                                class="required-red">*</span></label>
                                                            <span class="info-container">
                                                                <img className="info-question" src="Images/info-icon.png" alt="Info-icon" style={{ width: "15px" }} />
                                                                <span className="Grid-info-icon text-left" style={{ width: "235px", top: "-7px", left: "12px", top: "-7px", fontSize: "12px" }}>Maximum number allowed  is 1000</span>
                                                            </span>
                                                            <input type="text" class="form-control slider-txtbox " max="500" id="charecterLimitMax"
                                                                placeholder="Enter Max Number" value={this.state.maxNumber} onChange={(e) => this.handleQues(10, e)} />
                                                        </div>
                                                    </div> : null}
                                                {/* <!--number control end here-->*/}

                                                <div class="col-md-12 mb-3 mt-3 float-left">
                                                    <label class="sa-formlabbel d-block" for="question">Is this question mandatory?
                      </label>
                                                    <div class="custom-control custom-switch float-left">
                                                        <input type="checkbox" class="custom-control-input yellow-bg-switch" data-toggle="modal" id="questionMandatory" checked={this.state.isMandatoryField} onChange={(e) => this.handleQues(7, e)} />
                                                        <label class="custom-control-label" for="questionMandatory">{this.state.isMandatoryField ? "Yes" : "No"}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 mb-3 float-left">
                                                    <label class="sa-formlabbel d-block" for="question">Status <span><a href="#" class="ml-1"></a></span>
                                                    </label>
                                                    <div class="custom-control custom-switch float-left">
                                                        <input type="checkbox" class="custom-control-input yellow-bg-switch" data-toggle="modal" id="statusSwitch" checked={this.state.isActive} onChange={(e) => this.handleQues(3, e)} />
                                                        <label class="custom-control-label" for="statusSwitch">{this.state.isActive ? "Active" : "Inactive"}</label>
                                                    </div>
                                                </div>
                                                <div class="modal-footer pb-4">
                                                    <button type="button" class="btn custom-secondary-btn ml-3" onClick={() => this.cancelQues()}>Cancel</button>
                                                    <button type="button" class="btn btn-continue ml-3" onClick={() => this.saveImg()}>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<!--Slider end here-->*/}

                                {this.state.tempQues != undefined && this.state.tempQues != null ? this.bindFormQues() : null}
                                {this.state.formType != "view" && this.state.tempQues != undefined && this.state.tempQues != null && this.state.tempQues != "" && this.state.tempQues != [] && (isDeletecount != this.state.tempQues.length) ?
                                    <div class="col-md-12 my-5 float-left">
                                        <div class="float-right">
                                            {this.state.hasChanges && (
                                                <button type="button" class="btn custom-secondary-btn ml-3" onClick={() => this.cancel()}>Clear</button>
                                            )}
                                            <button type="button" class="btn btn-continue ml-3" disabled={this.state.formType=="add" && !this.state.formName.trim()} onClick={() => this.saveForm()}>Save</button>
                                        </div>
                                    </div> : null}
                                {this.state.formType == "view" ?
                                    <div class="col-md-12 my-5 float-left">
                                        <div class="float-right">
                                            <button type="button" class="btn custom-secondary-btn ml-3" onClick={() => this.props.history.push({
                                                pathname: "/manageforms"
                                            })}>Back</button>
                                        </div>
                                    </div> : null}
                            </div>
                        </div>
                    </div>
                    {/* <!-- edit forms ends here -->*/}

                    <div className="modal pr-0" id="Attachment" data-backdrop="static" data-keyboard="false">

                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered modal-attach-style">
                            <div className="modal-content" style={{ "border": "0px" }}>


                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1">More Info</h4>
                                    <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.setState({ attachImg: "" })}>
                                        X</button>
                                </div>
                                {/* Modal body */}
                                {(this.state.currentLabel != "" && this.state.currentLabel != " " && this.state.currentLabel != undefined && this.state.currentLabel != null) || (this.state.currentDesc != "" && this.state.currentDesc != " " && this.state.currentDesc != undefined && this.state.currentDesc != null) ?
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <React.Fragment>
                                                    <MapInteractionCSS minScale={1} maxScale={3.5} showControls >
                                                        <img src={this.state.attachImg} alt="binded-image" class="w-100" />
                                                    </MapInteractionCSS>
                                                </React.Fragment>
                                            </div>
                                            <div className="col-md-6">
                                                <h2 className="image-attach-label">{this.state.currentLabel}</h2>
                                                <p className="image-attach-para">{this.state.currentDesc}</p>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <React.Fragment>
                                                    <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                                        <img src={this.state.attachImg} alt="binded-image" class="w-100" />
                                                    </MapInteractionCSS>
                                                </React.Fragment>
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }

} export default withTranslation()(AddFormComponent);
